import { useState } from "react";
import { api } from "../../lib/api";
import { formatSgd, apiErr } from "../../lib/utils";
import { toast } from "sonner";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";
import { formatBandColor } from "./HazardsPanel";

export function OcrRegister({ register, onChanged }) {
  const [action, setAction] = useState({});
  const setStatus = async (r, status) => {
    try { await api.put(`/climate-risk/register/${r.id}`, { status }); toast.success(`${r.ocr_id} → ${status}`); onChanged(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const addAction = async (r) => {
    const text = (action[r.id] || "").trim();
    if (!text) return;
    try {
      await api.put(`/climate-risk/register/${r.id}`, { add_action: text });
      toast.success("Action added"); setAction((p) => ({ ...p, [r.id]: "" })); onChanged();
    } catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <div className="space-y-2">
      {register.map((r) => (
        <div key={r.id} className="card-flat p-4" data-testid={`ocr-row-${r.ocr_id}`}>
          <div className="flex items-start justify-between gap-3 flex-wrap">
            <div className="min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-mono text-accent text-xs font-bold">{r.ocr_id}</span>
                <span className="font-semibold text-sm">{r.facility_name}</span>
                <Badge variant="outline" className="text-[9px] uppercase">{r.hazard_type}</Badge>
                <span className={`font-mono text-sm font-bold ${formatBandColor(r.band)}`}>{r.score}</span>
                <span className={`text-[10px] uppercase tracking-wide ${formatBandColor(r.band)}`}>{r.band}</span>
              </div>
              <div className="text-xs text-muted-foreground mt-1">
                {r.hazard_name} · asset at risk {formatSgd(r.asset_value_at_risk)} · plant at risk {formatSgd(r.plant_at_risk)} · revenue exposed {formatSgd(r.revenue_exposed)}
              </div>
            </div>
            <Select value={r.status} onValueChange={(v) => setStatus(r, v)}>
              <SelectTrigger className="w-32 h-8 text-xs" data-testid={`ocr-status-${r.ocr_id}`}><SelectValue /></SelectTrigger>
              <SelectContent>
                {["open", "mitigating", "monitoring", "closed"].map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          {(r.mitigation_actions || []).length > 0 && (
            <ul className="mt-2 space-y-1">
              {r.mitigation_actions.map((a, i) => (
                <li key={i} className="text-[11px] text-muted-foreground flex gap-2">
                  <span className="text-accent">→</span>{a.text}
                  <span className="text-muted-foreground/50 font-mono">({(a.at || "").slice(0, 10)})</span>
                </li>
              ))}
            </ul>
          )}
          <div className="flex gap-2 mt-2">
            <Input placeholder="Add mitigation / adaptation action…" className="h-8 text-xs"
              value={action[r.id] || ""} onChange={(e) => setAction((p) => ({ ...p, [r.id]: e.target.value }))}
              data-testid={`ocr-action-input-${r.ocr_id}`} />
            <Button size="sm" variant="outline" onClick={() => addAction(r)} data-testid={`ocr-action-add-${r.ocr_id}`}>Add</Button>
          </div>
        </div>
      ))}
      {!register.length && <div className="text-sm text-muted-foreground py-8 text-center">No own-climate risks yet — entries appear automatically when a facility crosses the High threshold.</div>}
    </div>
  );
}
